import BaseStyle from '@primevue/core/base/style';

var theme = function theme(_ref) {
  var dt = _ref.dt;
  return "\n.p-confirmdialog .p-dialog-content {\n    display: flex;\n    align-items: center;\n    gap:  ".concat(dt('confirmdialog.content.gap'), ";\n}\n\n.p-confirmdialog-icon {\n    color: ").concat(dt('confirmdialog.icon.color'), ";\n    font-size: ").concat(dt('confirmdialog.icon.size'), ";\n    width: ").concat(dt('confirmdialog.icon.size'), ";\n    height: ").concat(dt('confirmdialog.icon.size'), ";\n}\n");
};
var classes = {
  root: 'p-confirmdialog',
  icon: 'p-confirmdialog-icon',
  message: 'p-confirmdialog-message',
  pcRejectButton: 'p-confirmdialog-reject-button',
  pcAcceptButton: 'p-confirmdialog-accept-button'
};
var ConfirmDialogStyle = BaseStyle.extend({
  name: 'confirmdialog',
  theme: theme,
  classes: classes
});

export { ConfirmDialogStyle as default };
//# sourceMappingURL=index.mjs.map
